/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type SsoTableSsoFragment = { __typename: 'Sso', id: string, domain: string, verificationStatus: Types.DomainVerificationStatus, provider?: { __typename: 'OidcProvider', displayName?: string | null, strategy: Types.SsoProviderStrategy, validationStatus?: Types.SsoValidationStatus | null, options: { __typename: 'OidcOptions', clientId?: string | null, clientSecret?: string | null, issuer?: string | null, discoveryUrl?: string | null, authorizationEndpoint?: string | null, jwksUri?: string | null } } | { __typename: 'SamlProvider', displayName?: string | null, strategy: Types.SsoProviderStrategy, validationStatus?: Types.SsoValidationStatus | null, options: { __typename: 'SamlOptions', entityId?: string | null, signInEndpoint?: string | null, signingCert?: string | null } } | null };

export const SsoTableSsoFragmentDoc = gql`
    fragment SsoTableSso on Sso {
  id
  domain
  verificationStatus
  provider {
    ... on OidcProvider {
      displayName
      strategy
      validationStatus
      options {
        clientId
        clientSecret
        issuer
        discoveryUrl
        authorizationEndpoint
        jwksUri
      }
    }
    ... on SamlProvider {
      displayName
      strategy
      validationStatus
      options {
        entityId
        signInEndpoint
        signingCert
      }
    }
  }
}
    `;